import React from "react";
import './CalculatorContent.scss'
import SparePartsTable from "./components/sparePartsTable/SparePartsTable";
import WorksTable from "./components/worksTable/WorksTable";

interface ICalculatorContentProps {
  model: string
  motor: string
  transmission: string
  drive: string
  pm: string
  pmData: App.IObject
  tab: number
  changeTab: (tab: number) => void
}

export default class CalculatorContent extends React.Component<ICalculatorContentProps, any> {

  render() {
    return <div className='calculator-content'>
      <div>
        <div className='calculator-content-head'>
          <h3>{`${this.props.model} ${this.props.motor}, ${this.props.transmission}, ${this.props.drive}`}</h3>
          <h2>{this.props.pm}</h2>
        </div>
        <div className='calculator-content-result'>
          <div className='calculator-content-result-tabs'>
            <div
              className={this.props.tab === 1 ? 'active' : ''}
              onClick={() => this.props.changeTab(1)}
            >
              <span>Регламентные работы</span>
            </div>
            <div
              className={this.props.tab === 2 ? 'active' : ''}
              onClick={() => this.props.changeTab(2)}
            >
              <span>Запасные части</span>
            </div>
          </div>
          <div className='calculator-content-result-content'>
            {
              this.props.tab === 1 ?
                <WorksTable data={this.props.pmData.works}/>
                :
                <SparePartsTable data={this.props.pmData.spareparts}/>
            }
          </div>
        </div>
      </div>
    </div>
  }
}